import {
  ChargeSmallCard,
  ChargeSmallCardTitle,
  CouponCount,
} from "@/pages/profile/components/atom";
import styled from "styled-components";
import RightArrowIcon from "@/assets/icons/profile/right-arrow";

export function CouponCard({
  coupon,
  total = 0,
  price = 0,
  onClickDetail,
  symbol,
  className,
}: {
  coupon: string;
  total: number;
  price: number | string;
  symbol: string;
  className?: string;
  onClickDetail?: () => void;
}) {
  return (
    <CouponSmallCard onClick={onClickDetail} className={className}>
      <ContentArea>
        <ChargeSmallCardTitle>
          <span>{coupon}</span>
          <CouponCount>{total}</CouponCount>
        </ChargeSmallCardTitle>
        <PriceArea>
          <span className="symbol">{symbol} </span>
          <span className="price">{price}</span>
        </PriceArea>
      </ContentArea>
      <RightArrowIcon />
    </CouponSmallCard>
  );
}

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const PriceArea = styled.div`
  height: 14px;
  line-height: 14px;
  margin-top: 3px;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  .symbol {
    font-weight: normal;
    font-size: 10px;
  }
  .price {
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    color: #d9dfe0;
  }

  // @media (max-width: 1440px) {
  //   display: flex;
  //   align-items: center;
  //   gap: 5px;
  // }
`;

const CouponSmallCard = styled(ChargeSmallCard)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: unset !important;
  background: #292b2f;
  border: 1px solid #404246;
  border-radius: 4px;
  height: 64px;
  cursor: pointer;
  padding: 8px 12px;
  &.vocher {
    ${PriceArea} {
      height: max-content;
      margin-top: 8px;
      .symbol,
      .price {
        font-weight: 600;
        font-size: 14px;
        color: #d9dfe0;
      }
    }
  }
`;
